import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractNgModelComponent } from '../abstract-ng-model/abstract-ng-model.component';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: InputComponent,
    },
  ],
})
export class InputComponent
  extends AbstractNgModelComponent
  implements OnChanges
{
  @Input() label = '';
  @Input() placeholder = '';
  @Input() errorText = '请将信息填写完整';
  @Input() error = false;
  @Input() formControl!: FormControl;
  override value: any;

  ngOnChanges(changes: SimpleChanges): void {}
}
